import { BrandLogo } from '@silvertours/front-entities';
import type { BrandName } from '@silvertours/common-landingpages-view';
import { WidgetSearchForm } from '../SearchFormLegacy';
import { Wrapper, LogoWrapper, Logo } from './WidgetStage.styles';

type Props = {
  brandName: BrandName;
};

/**
 * Rendered sizes:
 * - 250x250
 * - 300x250
 * - 300x400
 * - 300x600
 * - 320x480
 * - 800x250
 * - 970x250
 * @see https://silvertours.atlassian.net/browse/DGN-1785
 * @see https://silvertours.atlassian.net/browse/DGN-1784
 */
const WidgetStage = ({ brandName }: Props) => (
  <Wrapper>
    <WidgetSearchForm />
    <LogoWrapper id="logo">
      <Logo>
        <BrandLogo brand={brandName} height="25" />
      </Logo>
    </LogoWrapper>
  </Wrapper>
);

export { WidgetStage };
